import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button } from '@chakra-ui/react';
import React from 'react';

interface Props {
  onOpenApplication: () => void;
}

const InitiatedByUniNotification: React.FC<Props> = ({ onOpenApplication }) => (
  <Alert status="info" flexDirection="column" mb="4">
    <Box display="flex" mb={2}>
      <AlertIcon />
      <Box flex="1">
        <AlertTitle>Application has not been submitted</AlertTitle>
        <AlertDescription>
          This application was created by the university. Use the button below to open the submission portal.
        </AlertDescription>
      </Box>
    </Box>

    <Button size="md" variant="solid" onClick={onOpenApplication} ml={8}>
      Open application
    </Button>
  </Alert>
);

export default InitiatedByUniNotification;
